
import LayoutMain from '@/layouts';

import { routePre } from '@/config'



const frameIn = [
    {
        path: '/',
        meta: {
            title: '小海优品'
        },
        redirect:{
            name: 'home_index'
        },
        component: LayoutMain,
    },
];


const requireRoutes = require.context('./modules', true, /\.js$/)


requireRoutes.keys().filter(key => {
    frameIn.push(requireRoutes(key).default);
})

const errorPage = [
    {
        path: routePre + '500',
        name: '500',
        meta: {
          title: '500',
        },
        component: () => import('@/pages/error/500'),
    },{
        path: routePre + '404',
        name: '404',
        meta: {
            title: '404',
        },
        component: () => import('@/pages/error/404.vue'),
    },{
        path: routePre + '403',
        name: '403',
        meta: {
            title: '403',
        },
        component: () => import('@/pages/error/403.vue'),
    },{
        path: routePre + 'loading',
        name: 'loading',
        meta: {
            title: '请稍等',
        },
        component: () => import('@/pages/loading/index.vue'),
    },
]

const agreement = [
    {
        path: routePre + 'agreement/privacy',
        name: `privacy`,
        header: 'home',
        meta: {
            title: '隐私政策',
            is_navbar: false
        },
        component: () => import('@/pages/agreement/privacy'),
    },{
        path: routePre + 'agreement/service',
        name: `service`,
        header: 'home',
        meta: {
            title: '服务协议',
            is_navbar: false
        },
        component: () => import('@/pages/agreement/service'),
    },{
        path: routePre + 'agreement/certificate',
        name: `certificate`,
        header: 'home',
        meta: {
            title: '数字证书服务协议',
            is_navbar: false
        },
        component: () => import('@/pages/agreement/certificate'),
    },
    {
        path: routePre + 'agreement/userAuthorization',
        name: `userAuthorization`,
        header: 'home',
        meta: {
            title: '用户授权协议',
            is_navbar: false
        },
        component: () => import('@/pages/agreement/userAuthorization'),
    },
      
]

// 公共路由
export const frameInRoutes = frameIn;

export default [...frameIn, ...errorPage, ...agreement];